<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Department</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Department</li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" @click="getDepartments">All</a>
                  <a class="dropdown-item" @click="getNewDepartment">New</a>
                  <a class="dropdown-item" @click="getDepartmentApproved"
                    >Approved</a
                  >
                  <a class="dropdown-item" @click="getDepartmentRejected"
                    >Rejected</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="departments"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Leave Approve</h3>
                <p>Are you sure want to approve for this leave?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required } from "vuelidate/lib/validators";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },
  data() {
    return {
      headers: [
        {
          text: "Department Name",
          align: "start",
          value: "name",
        },
        {
          text: "Status",
          align: "start",
          value: "stat",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
      name: "",
      departments: [],
      department: {},
      submitted: false,
      loading: false,
      error: "",
      dialogStatus: false,
      currentUser: authenticationService.currentUserValue,
      fullName: "",
    };
  },

  watch: {
    dialogStatus(val) {
      val || this.closeStatus();
    },
  },

  methods: {
    setLeaveStatus(item) {
      this.department = item;
      this.dialogStatus = true;

      this.fullName =
        this.currentUser.employee.firstName +
        " " +
        this.currentUser.employee.lastName;
    },

    changeLeaveStatus(status) {
      this.submitted = true;
      this.department.status = status;
      const id = this.department.id;
      this.department.approvedByGMD = this.fullName;
      this.department.approvedDateByGMD = new Date();
      console.log(this.department.status);
      this.loading = true;
      organizationService.updateDepartmentByGMD(id, this.department).then(
        (id) => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          organizationService.getDepartments(unit.id).then((o) => {
            this.departments = o.filter(
              (c) => c.approvedByGMD == null && c.status == 0
            );
            this.closeStatus();
          });

          console.log("department approved");
        },
        (error) => {
          this.error = error;
          this.closeStatus();
          this.loading = false;
        }
      );
    },

    setDepartment(item) {
      this.department = item;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    getNewDepartment() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getDepartments(unit.id).then(
        (model) => {
          this.departments = model.filter(
            (c) => c.approvedByGMD == null && c.status == 0
          );
        },
        (error) => {
          error = error;
        }
      );
    },

    getDepartments() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getDepartments(unit.id).then(
        (model) => {
          this.departments = model;
          // .filter(
          //   (c) => c.approvedByGMD == null && c.status == 0
          // );
        },
        (error) => {
          error = error;
        }
      );
    },

    getDepartmentApproved() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getDepartments(unit.id).then(
        (model) => {
          this.departments = model.filter((c) => c.status == 1);
          // console.log("leaves:", model[0]);
        },
        (error) => {
          error = error;
        }
      );
    },

    getDepartmentRejected() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getDepartments(unit.id).then(
        (model) => {
          this.departments = model.filter((c) => c.status == 2);
          // console.log("leaves:", model[0]);
        },
        (error) => {
          error = error;
        }
      );
    },
  },

  mounted() {
    this.getNewDepartment();
  },
  name: "companydepartments",
};
</script>


// WEBPACK FOOTER //
// src/components/miscs/departApprovedByGMD.vue